export const firebaseEnv = {
    production: false,
    firebase: {
      
        vapidKey: 'BFdfKeV590D6GZtTzVlnzLaSreFOp2mIidHVwMQJumhnlqJrhH3G9o7BqoqnI499RBFOq4Y_zKD_0at8YwDaqf0',
        appConfig:{
            apiKey: "AIzaSyDmqUQ60D7uJEXjS3gbG3MzW85_jQipZiE",
            authDomain: "kachiing-c925e.firebaseapp.com",
            databaseURL: "https://kachiing-c925e-default-rtdb.asia-southeast1.firebasedatabase.app",
            projectId: "kachiing-c925e",
            storageBucket: "kachiing-c925e.appspot.com",
            messagingSenderId: "65260160890",
            appId: "1:65260160890:web:809020a158e5ae90b1b8c3",
        }
    },
    
  };
  